import cloneDeep from 'lodash/cloneDeep'
import IdFromIri from '@/services/IdFromIri'

class InvoicesFormMapper {
    toEntity(values) {
        const entity = cloneDeep(values)
        if (entity.company) entity['company'] = entity['company']['@id']
        if (entity.restaurant)
            entity['restaurant'] = entity['restaurant']['@id']

        return entity
    }

    fromEntity(entity) {
        const values = cloneDeep(entity)
        values.periodStart = values.periodStart.substr(0, 10)
        values.periodEnd = values.periodEnd.substr(0, 10)

        // the shape the form builds from a loaded invoice (reference by @id, type,
        // relationId): normalising it here keeps an untouched invoice clean
        for (const field of ['restaurant', 'company']) {
            if (values[field]) values[field] = { '@id': values[field]['@id'] }
        }
        values.type = values.restaurant
            ? 'restaurant'
            : values.company
            ? 'company'
            : ''
        const relation = values.company || values.restaurant
        values.relationId = relation ? IdFromIri.getId(relation['@id']) : null

        return values
    }
}

export default new InvoicesFormMapper()
